export const formatTime = (timeString: string): string => {
  try {
    const [hours, minutes] = timeString.split(':').map(Number);

    if (isNaN(hours) || isNaN(minutes)) {
      return timeString;
    }

    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return timeString;
  }
};

export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
  const toast = document.createElement('div');
  toast.className = `fixed top-24 right-4 z-50 px-6 py-4 rounded-lg shadow-lg text-white font-semibold animate-slide-in ${
    type === 'success' ? 'bg-green-600' :
    type === 'error' ? 'bg-red-600' :
    'bg-blue-600'
  }`;
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = 'slide-out 0.3s ease-in-out';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
};

const RATE_LIMIT_DURATION = 60000;

export const checkRateLimit = (key: string): boolean => {
  const now = Date.now();
  const lastSubmit = localStorage.getItem(`rate_limit_${key}`);

  if (lastSubmit) {
    const timeSinceLastSubmit = now - parseInt(lastSubmit, 10);
    if (timeSinceLastSubmit < RATE_LIMIT_DURATION) {
      const secondsRemaining = Math.ceil((RATE_LIMIT_DURATION - timeSinceLastSubmit) / 1000);
      showToast(`Please wait ${secondsRemaining} seconds before submitting again`, 'error');
      return false;
    }
  }

  localStorage.setItem(`rate_limit_${key}`, now.toString());
  return true;
};
